@for (config of configs; track config.id) {
  <div class="banner" [class]="getColorClass(config)">
    <div class="banner-content">
      <lib-svg-icon [class.warning-icon]="config.type.type === 'warning'"
                    [svgHeight]="'24px'" [svgName]="config.icon" 
                    [svgWidth]="'24px'"></lib-svg-icon>
      <div class="banner-text">
      @if (config.title) {
        <div class="banner-title">{{ config.title }}</div>
      }
        <div #previewBanner class="banner-message" 
              [innerHTML]="normalizeMessage(config.message)"
              [class.preview-banner]="config.category" [class.ql-editor]="config.category"></div>
      @if (config.hyperlink) {
        <div class="banner-link-container">
          <a class="banner-link" [routerLink]="config.hyperlink.route">{{ config.hyperlink.text }}</a>
        </div>
      }
      </div>
    </div>
    <div class="banner-close-container">
      <button class="banner-close" [class.pointers]="!allowPointerEvents()" (click)="dismiss(config)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}